import React from 'react';

class ReloadButton extends React.Component {
  handleReload = () => {
    window.location.reload(); // ページをリロードする
  }

  render() {
    return (

      <main className="flex md:my-3 md:mx-2 items-center justify-center pointer-events-auto">
        <div
          className="flex md:rounded-xl bg-black bg-opacity-80 text-white p-1 md:py-1"
          x-data="app"
        >
          <div className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white">


          <button onClick={this.handleReload}>GO</button>




          </div>
        </div>
      </main>
    );
  }
}

export default ReloadButton;
